exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ContextMenuItem__item{cursor:pointer;margin:0;padding:8px 14px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ContextMenuItem__item:hover{background:#ffefd7}.ContextMenuItem__disabled{cursor:default;color:grey}.ContextMenuItem__item.ContextMenuItem__disabled:hover{background:transparent}", ""]);

// Exports
exports.locals = {
	"item": "ContextMenuItem__item",
	"disabled": "ContextMenuItem__disabled"
};